<template>
    <div :class="[companyClass , canScroll]">
        <div class="page-mobilemoneyprovider flex column mb-20">
            <div class="page-header">
				<h1 class="pageTitle">{{pageTitle}}</h1>
				<h4>{{pageSubtitle}} </h4>
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
					<el-breadcrumb-item>settings</el-breadcrumb-item>
					<el-breadcrumb-item>taxes</el-breadcrumb-item>
					<el-breadcrumb-item>{{pageTitle}}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>

			<div class="mt-0 w-100">
				<div style="float: right;">
					<el-button v-show="userPermissionsFilter.addfinancingthreshhold" 
                     type="primary" icon="el-icon-plus" @click="handleNew">
                    </el-button>

					<el-button type="warning" icon="el-icon-tickets"
					v-show="userPermissionsFilter.viewfinancingthreshhold" 
						@click="handleExit" title="view list"></el-button>

					<el-button type="primary"
                     @click="validateAndSave" v-show="canSaveChanges" :disabled="saveChanges">
                     <i class="mdi mdi-content-save"></i></el-button>
				</div>
			</div>

			<div class="mt-10">
				<el-row :gutter="20">
					<el-col :span="8">
						<span>Company</span><span :class="required"> *</span>
                        <el-select v-model="threshold.companyID" filterable clearable placeholder="Select Company" class="mb-10" 
                        style="width:100%" name="company" v-validate="'required'" data-vv-as="company"
						@change="propertyChanged" :disabled="readOnlyMode">
                            <el-option
                            v-for="company in companyNames"
                            :key="company.id"
                            :label="company.name"
                            :value="company.id">
                            </el-option>
                        </el-select>
                        <transition name="fade">
                            <span class="danger-text">{{ errors.first('company') }}</span>
                        </transition>
					</el-col>
					<el-col :span="8">
						<span>Minimum Amount</span><span :class="required"> *</span>
                        <el-input placeholder="Minimum Amount" v-model="threshold.minimumAmount"
                                    name="minimumamount" v-validate="'required|decimal:5|min:1'" data-vv-as="minimum amount"
									@blur="propertyChanged" :readonly="readOnlyMode"></el-input>
                        <transition name="fade">
                            <span class="danger-text">{{ errors.first('minimumamount') }}</span>
                        </transition>
					</el-col>
				</el-row>

				<el-row :gutter="20" class="mt-10">
                        <el-col :span="8">
                            <span>Activate Notifications</span>
                            <el-checkbox class="w-100" v-model="threshold.notificationActive" border>Send a notification on expiring</el-checkbox>
                        </el-col>
                        <el-col :span="8" v-show="threshold.notificationActive">
                            <span>Timespan before expiring</span>
                            <el-input placeholder="Timespan" v-model="threshold.timespan"></el-input>
                        </el-col>
                        <el-col :span="8" v-show="threshold.notificationActive">
                            <span>Timespan Type</span>
                            <el-select v-model="threshold.timeSpanType" filterable clearable placeholder="Timespan Type" class="mb-10" 
                            style="width:100%">
                                <el-option
                                v-for="tframe in timeframes"
                                :key="tframe.value"
                                :label="tframe.label"
                                :value="tframe.value">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="mt-10" v-show="threshold.notificationActive">
                        <el-col :span="12">
                            <span>Mobile Number Alerts</span>
                            <el-input v-model="threshold.notificationPhoneNumbers" type="textarea" :rows="2" placeholder="Enter mobile number separated by a comma"></el-input>
                        </el-col>
                        <el-col :span="12">
                            <span>Email Alerts</span>
                            <el-input v-model="threshold.notificationEmails" type="textarea" :rows="2" placeholder="Enter email addresses separated by a comma"></el-input>
                        </el-col>
                    </el-row>

				<div class="mt-10">
                    <el-button type="primary" @click="validateAndSave"><i></i> Save Threshold</el-button>
					<el-button type="info" @click="clearState"><i></i> Reset</el-button>
                </div>
			</div>

        </div>
    </div>
</template>


<script>
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/' 
import { bus } from '@/main'
import { Validator } from 'vee-validate'

export default {
	name: 'AddThreshhold',
	data() {
		return {
			threshold: {
				id: 0,
				companyID: '',
				minimumAmount: '',
				notificationActive: false,
				timespan: 0,
				timeSpanType: '',
				notificationPhoneNumbers: '',
				notificationEmails: ''
			}
		}
	},
	computed: {
		canSaveChanges() {
			return this.saveChanges && !this.readOnlyMode;
		},
		readOnlyMode() {
			return !(this.userPermissionsFilter.addfinancingthreshhold 
			|| this.userPermissionsFilter.editfinancingthreshhold);
		}
	},
	methods: {
		createNew() {
			router.push('/addfinancingthreshhold');
            this.clearState();
		},
		viewThreshold() {
			router.push('/financingthreshholds');
		},
		clearState() {
			this.threshold = {
				id: 0,
				companyID: '',
				minimumAmount: '',
				notificationActive: false,
				timespan: 0,
				timeSpanType: '',
				notificationPhoneNumbers: '',
				notificationEmails: ''
			};
			this.$validator.reset();
		},
		validateAndSave() {
			let self = this;
            this.$validator.validateAll()
            .then(result=> {
                if(result){
					this.saveFinancingThreshHold(self.threshold)
					.then(result=> {
						if(result.id > 0){
							self.threshold = result;
							this.successMessage('Threshold saved successfully.');
							this.entitySaved();
						}
						else{
							this.errorMessage('Threshold not saved.');
						}
					})
					.catch(err=> this.errorMessage('An error occured.'));
                }
            })
            .catch(err=> console.log(err));
		}
	},
	created() {
		this.newEvent = 'createNew';
        this.saveEvent = 'validateAndSave';
        this.exitEvent = 'viewThreshold';
        this.$on(this.saveEvent, this.validateAndSave);
        this.$on(this.newEvent, this.createNew);
		this.$on(this.exitEvent, this.viewThreshold);
		
		this.getCompanyNames();

		var id = router.currentRoute.params.id;

		this.pageTitle = 'add threshold';
		this.pageSubtitle = 'create threshold';

        if(id){
            this.pageTitle = 'update threshold';
            this.findFinancingThreshHold(id)
         	.then(result=> {
             this.threshold = result;
         });
        }
	},
	mixins: [PermissionsMixins]
}
</script>

<style lang="scss" scoped>

</style>


